$j = jQuery.noConflict();
